const cancelledPresenter = {
  isCancelled: (bet) => { return !!bet.cancelled },
  cancelledReason: (bet) => { return bet.cancelled_reason || null }
}

export default cancelledPresenter
